import React from 'react';
import { SectionList, TouchableOpacity, View } from 'react-native';
import { useNavigation, useRoute } from '@react-navigation/native';

import tw from '@/styles/tailwind';
import Text from '@/components/Text';
import Icon from '@/components/IcomoonIcon';
import { REPORTS, REPORT_GROUPS, ReportKey } from './registry';

type Props = {
  // Inyectables como props (panel Vinte, render inline) o vía route.params (admin, como ruta).
  communityId?: string;
  detailRoute?: string;
};

// Arma las secciones (3 familias) a partir del registry, respetando REPORT_GROUPS.
function buildSections() {
  const entries = Object.entries(REPORTS) as [ReportKey, (typeof REPORTS)[ReportKey]][];
  return REPORT_GROUPS.map(group => ({
    title: group,
    data: entries
      .filter(([, r]) => r.group === group)
      .map(([key, r]) => ({ key, title: r.title })),
  }));
}

// Índice de reportes compartido (admin + panel Vinte). No conoce los reportes:
// solo lista el catálogo y navega a la ruta de detalle parametrizada con reportKey.
export default function ReportsScreen(props: Props) {
  const route = useRoute<any>();
  const navigation = useNavigation<any>();

  const communityId = props.communityId ?? route.params?.communityId;
  const detailRoute = props.detailRoute ?? route.params?.detailRoute;

  return (
    <SectionList
      style={tw`flex-1 bg-background`}
      contentContainerStyle={tw`py-4`}
      sections={buildSections()}
      keyExtractor={item => item.key}
      stickySectionHeadersEnabled={false}
      renderSectionHeader={({ section }) => (
        <Text style={tw`px-5 pt-4 pb-2 text-gray-400 text-xs font-600 uppercase`}>
          {section.title}
        </Text>
      )}
      renderItem={({ item }) => (
        <TouchableOpacity
          style={tw`row items-center justify-between bg-white mx-4 my-1 px-4 py-3.5 rounded-xl border border-gray-100`}
          onPress={() => navigation.navigate(detailRoute, { reportKey: item.key, communityId })}
        >
          <Text style={tw`text-gray-800`}>{item.title}</Text>
          <Icon name="chevron-right" color={tw.color('gray-400')} />
        </TouchableOpacity>
      )}
    />
  );
}
